<app-loader *ngIf="loaderIcon | async"></app-loader>

<div class="vendorSearch" *ngIf="shipperSearch">
  <!-- Filter Section -->
  <div class="row mb-2">

    <div class="col-md-3">
      <label>Search Field</label>
      <select class="form-select form-select-sm" [(ngModel)]="searchField">
        <option value="FirstName">First Name</option>
        <option value="LastName">Last Name</option>
        <option value="CompanyName">Company Name</option>
        <option value="Telephone">Telephone</option>
        <option value="Mobile">Mobile</option>
        <option value="Email">Email</option>
        <option value="City">City</option>
        <option value="State">State</option>
        <option value="Zip Code">Zipcode</option>
      </select>
    </div>

    <div class="col-md-3">
      <label>Search Value</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="searchValue" (keyup.enter)="resetAndLoad()">
    </div>
  </div>

  <!-- Scrollable Table -->
  <div class="row">
    <div class="col-12">
      <div class="scroll_outer" style="height:400px; overflow-y:auto;" #scrollContainer (scroll)="onScroll()">
        <table class="table table-striped text-center mb-0">
          <thead style="position: sticky; top: 0; z-index: 9; background-color: #fff;">
            <tr>
              <th class="text-start" style="width: 6%">ID</th>
              <th class="text-start" style="width: 10%">First Name</th>
              <th class="text-start" style="width: 10%">Last Name</th>
              <th class="text-start" style="width: 20%">Address</th>
              <th class="text-start" style="width: 10%">City</th>
              <th class="text-start" style="width: 8%">State</th>
              <th class="text-start" style="width: 8%">Country</th>
              <th class="text-start" style="width: 8%">Zip</th>
              <th class="text-start" style="width: 10%">Telephone</th>
              <th class="text-start" style="width: 10%">Cell Phone</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data" (click)="shipperDetails(item, $event)">
              <td class="text-start">{{ item.MarketShippingId }}</td>
              <td class="text-start">{{ item.FirstName }}</td>
              <td class="text-start">{{ item.LastName }}</td>
              <td class="text-start">{{ item.Address }}</td>
              <td class="text-start">{{ item.City }}</td>
              <td class="text-start">{{ item.StateId }}</td>
              <td class="text-start">{{ item.CountryId }}</td>
              <td class="text-start">{{ item.Zip }}</td>
              <td class="text-start">{{ item.Telephone }}</td>
              <td class="text-start">{{ item.CellPhone }}</td>
            </tr>
            <tr *ngIf="data.length == 0">
              <td colspan="12" style="text-align: center;">No records found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="form-container" *ngIf="!shipperSearch">
  <div [formGroup]="shipperForm">
    <div class="row g-3 align-items-center">
      <div class="col-md-3">
        <label class="form-label">Shipping #</label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="marketShippingId">
        </div>
      </div>

    <div class="col-md-3 d-flex align-items-center">
      <!-- Image section -->
      <div class="Image-box position-relative me-3">
        <input *ngIf="isDefaultImage" type="file" accept=".jpg,.jpeg,.png" (change)="addImage($event)"
          class="form-control position-absolute top-0 start-0 w-100 h-100 opacity-0" style="cursor: pointer;">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center" [ngClass]="{'no-photo': isNoPhoto}">
          <img [src]="imagePreviewUrl" id="ImagePreview" class="img-fluid"
            style="pointer-events: none; width: 100px; height: auto;">
        </div>
      </div>
    
      <!-- Buttons section -->
      <div class="d-flex flex-column">
        <input type="file" id="ImageFileInput" (change)="addImage($event)" accept=".jpg,.jpeg,.png" hidden>
    
        <ejs-tooltip id="tooltipMImageAdd" target="#btnMImageAdd" position="RightCenter" openMode="Auto"
          windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
          <button id="btnMImageAdd" class="btn btnAS btn-sm mb-2" type="button" (click)="addImageClick()">{{imageAddbtnText}}</button>
        </ejs-tooltip>
    
        <ejs-tooltip id="tooltipMImageRemove" target="#btnMImageRemove" position="RightCenter" openMode="Auto"
          windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
          <button id="btnMImageRemove" class="btn btnAS btn-sm" type="button" (click)="removeImage()"
            [disabled]="!canRemoveImage">REMOVE</button>
        </ejs-tooltip>
      </div>
    </div>

    </div>
    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label"><span style="color: red;">*</span>First Name</label>
        <input type="text" class="form-control" [class.is-invalid]="shipperForm.get('firstName')?.invalid" formControlName="firstName">
        <div class="invalid-feedback">First Name is required.</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Last Name</label>
        <input type="text" class="form-control" formControlName="lastName">
      </div>
    </div>

    <div class="row g-3 mt-1">
       <div class="col-md-6">
        <label class="form-label">Address</label>
        <textarea class="form-control" rows="2" formControlName="address"></textarea>
      </div>
      <div class="col-md-4">
        <label for="country" class="form-label">Country</label>
        <select class="form-select" id="country" formControlName="countryId" (change)="onCountryChange()">
          <option [value]="null" disabled selected>Select</option>
          @for (c of countries; track c.Code) {
          <option [value]="c.Code">{{ c.Name }}</option>
          }
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label">City</label>
        <input type="text" class="form-control" formControlName="city">
      </div>
      <div class="col-md-4">
        <label class="form-label">State</label>
        <select class="form-select" id="state" formControlName="stateId" *ngIf="showStateDropDown"
          [class.is-invalid]="shipperForm.get('stateId')?.invalid">
          <option [value]="null" disabled selected>Select</option>
          @for (state of states; track state.StateCode) {
          <option [value]="state.StateCode">{{ state.StateName }}</option>
          }
        </select>
        <div class="invalid-feedback" *ngIf="showStateDropDown && shipperForm.get('stateId')?.errors?.['required']">State is required.</div>
        <input type="text" *ngIf="!showStateDropDown" maxlength="2" tabindex="9" class="form-control"
          [class.is-invalid]="shipperForm.get('stateCode')?.invalid"
          formControlName="stateCode">
        <div class="invalid-feedback" *ngIf="!showStateDropDown && shipperForm.get('stateCode')?.errors?.['required']">State is required.</div>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-3">
        <label class="form-label">ZipCode</label>
        <input type="text" class="form-control" [class.is-invalid]="shipperForm.get('zip')?.invalid" formControlName="zip">
        <div class="invalid-feedback" *ngIf="shipperForm.get('zip')?.errors?.['pattern']">Invalid zip code format.</div>
      </div>
     
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-3">
        <label class="form-label">Telephone</label>
        <ejs-maskedtextbox
          [mask]="PhoneNumberMask"
          [promptChar]="'_'"
          placeholder="(000)000-0000"
          name="telephone"
          id="telephone"
          formControlName="telephone">
        </ejs-maskedtextbox>
        <small class="text-danger" *ngIf="shipperForm.get('telephone')?.errors?.['invalidPhone'] && (shipperForm.get('telephone')?.dirty || shipperForm.get('telephone')?.touched)">
          Please enter a valid phone number.
        </small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Mobile</label>
        <ejs-maskedtextbox
          [mask]="PhoneNumberMask"
          [promptChar]="'_'"
          placeholder="(000)000-0000"
          name="cellPhone"
          id="cellPhone"
          formControlName="cellPhone">
        </ejs-maskedtextbox>
        <small class="text-danger" *ngIf="shipperForm.get('cellPhone')?.errors?.['invalidPhone'] && (shipperForm.get('cellPhone')?.dirty || shipperForm.get('cellPhone')?.touched)">
          Please enter a valid mobile number.
        </small>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-12 text-end">
        <button type="button" class="btn btnAS me-1" [disabled]="validateForm()" (click)="saveShippingDetails()">Save</button>
        <button type="button" class="btn btn-orange" (click)="closeShipperModal()">Close</button>
      </div>
    </div>
  </div>
</div>
